<div class="devices-page">
    <div class="header">
        <div class="title-search-container">
            <h1>{{ 'DEVICE.TITLE' | translate }}</h1>
            <div class="search-container">
                <div class="search-input-wrapper">
                    <input type="text" placeholder="{{ 'DEVICE.SEARCH' | translate }}" [(ngModel)]="filters.device"
                        (input)="applyFilters()" class="search-bar" />
                    <i class="fas fa-search search-icon"></i>
                                         <div class="actions">
            
            <button class="filter-button ms-3" (click)="onFilterOpen()">
                <i class="fas fa-sliders-h"></i>
            </button>
            </div>
                </div>

            </div>
        </div>
        <div class="actions">
            <button class="tertiary-button me-3" (click)="openReportModalForDevices(filteredDevices)">
                <img src="./icon/report.svg" class="me-2" />
                <span class="text-size">{{ 'REPORT.REPORT' | translate }}</span>
            </button>
            <button class="secondary-button multi-assignment" (click)="assignMultiRecords()"
            style="width: 12rem !important;">
                <img src="./icon/multi-assignment.svg" />
                <span class="text-size"> {{'BUTTONS.MULTI_ASSIGNMENT' | translate}}</span>
              </button>
            <button class="primary-button" (click)="onNewDeviceClick()">
                {{ 'BUTTONS.NEW_DEVICE' | translate }}
            </button>
        </div>
    </div>

    <div class="table-container">
        <table class="devices-table">
            <thead>
                <tr>
                    <th>
                        {{ 'DEVICE.LABEL' | translate }}
                        <button (click)="toggleSort('serialNumber')" class="sort-btn">
                            {{ currentSortColumn === 'serialNumber' && currentSortDirection === 'asc' ? '▲' : '▼' }}
                        </button>
                    </th>
                    <th>
                        {{ 'DEVICE.COMPANY' | translate }}
                        <button (click)="toggleSort('company')" class="sort-btn">
                            {{ currentSortColumn === 'company' && currentSortDirection === 'asc' ? '▲' : '▼' }}
                        </button>
                    </th>
                    <th>
                        {{ 'DEVICE.STATUS' | translate }}
                        
                    </th>
                    <th>
                        {{ 'DEVICE.SITE' | translate }}
                        <button (click)="toggleSort('site')" class="sort-btn">
                            {{ currentSortColumn === 'site' && currentSortDirection === 'asc' ? '▲' : '▼' }}
                        </button>
                    </th>
                    <th>
                        {{ 'DEVICE.LAST_USED' | translate }}
                        <button (click)="toggleSort('lastUsed')" class="sort-btn">
                            {{ currentSortColumn === 'lastUsed' && currentSortDirection === 'asc' ? '▲' : '▼' }}
                        </button>
                    </th>
                    <th>
                        {{ 'DEVICE.LAST_CALIBRATION' | translate }}
                        <button (click)="toggleSort('lastCalibration')" class="sort-btn">
                            {{ currentSortColumn === 'lastCalibration' && currentSortDirection === 'asc' ? '▲' : '▼' }}
                        </button>
                    </th>

                    <th>
                        {{ 'DEVICE.BATTERY_LEVEL' | translate }}
                       
                    </th>
                    

                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr class="table-row" *ngFor="let device of filteredDevices; trackBy: trackByDevice">
                    <td>
                        <div class="info-container">
                            <span *ngIf='device.favorite' class="star-icon"
                                [ngClass]="device.favorite ? 'fas fa-star' : 'far fa-star'"
                                attr.aria-label="{{ 'DEVICE.TOGGLE_FAVORITE' | translate }}" tabindex="0"></span>
                            <div class="text-container">
                                <span class="device-id">{{ device.serialNumber }}</span>
                                <span class="device-model">{{ device.model || 'N/A' }}</span>
                            </div>
                        </div>
                    </td>
                    <td>{{ device.company || 'N/A' }}</td>
                     <td>
                        <svg-icon
                        [src]="getStatusIcon(device)"
                        [svgStyle]="{width: '1.5em', height: '1.5em'}"
                        [title]="getStatusTitle(device)"
                        ></svg-icon>
                    </td>
                    <td>
                        {{ device.site.region ? device.site.region : ('DEVICE.REGION_NA' | translate) }} -
                        {{ device.site.name ? device.site.name : ('DEVICE.SITE_NA' | translate) }}
                    </td>
                    <td>{{ device.lastUsed |  date: 'dd/MM/yyyy':'UTC' }}</td>
                    <td>{{ device.lastCalibration | date:'dd/MM/yyyy':'UTC' }}</td>
                    <td >
                        <ng-container *ngIf="getDeviceStatusInfo(device).isConnected" [ngSwitch]="getBatteryIcon(device)">
                            <span *ngSwitchCase="'charging'"><svg-icon src="./icon/charging-battery.svg" [svgStyle]="{width: '2.2em', height: '2.2em'}" title="Charging"></svg-icon></span>
                            <span *ngSwitchCase="'low'"><svg-icon src="./icon/low-battery.svg" [svgStyle]="{width: '2.2em', height: '2.2em'}" [title]="device.batteryLevel + '%'" ></svg-icon> {{device.batteryLevel}}%</span>
                            <span *ngSwitchCase="'medium'"><svg-icon src="./icon/medium-battery.svg" [svgStyle]="{width: '2.2em', height: '2.2em'}" [title]="device.batteryLevel + '%'" ></svg-icon> {{device.batteryLevel}}%</span>
                            <span *ngSwitchCase="'battery'"><svg-icon src="./icon/battery.svg" [svgStyle]="{width: '2.2em', height: '2.2em'}" [title]="device.batteryLevel + '%'" ></svg-icon> {{device.batteryLevel}}%</span>
                            <span *ngSwitchCase="'full-battery'"><svg-icon src="./icon/full-battery.svg" [svgStyle]="{width: '2.2em', height: '2.2em'}" [title]="device.batteryLevel + '%'" ></svg-icon> {{device.batteryLevel}}%</span>
                            <span *ngSwitchCase="'unknown'"></span>
                            <span *ngSwitchDefault><svg-icon src="./icon/battery.svg" [svgStyle]="{width: '2.2em', height: '2.2em'}" [title]="device.batteryLevel + '%'" ></svg-icon> {{device.batteryLevel}}%</span>
                        </ng-container>
                    </td>
                    <td style="text-align: right;">
                        <button class="primary-button" (click)="viewDeviceDetails(device.serialNumber)">
                            {{ 'BUTTONS.DETAILS' | translate }}
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>